import PropTypes from "prop-types";

import { ErrorMessage, Field } from "formik";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";

function FormField({ label, name,required=false, ...rest }) {
  return (
    <MDBox mb={1.5}>
      <Field {...rest} {...((rest.type==="text"||rest.type==="number")&&{name})} as={MDInput} variant="outlined" label={required?<span style={{color:"red"}}>{label}</span>:label} fullWidth />
      <MDBox mt={0.75}>
        <MDTypography component="div" variant="caption" color="error" fontWeight="regular">
          <ErrorMessage name={name} />
        </MDTypography>
      </MDBox>
    </MDBox>
  );
}

FormField.propTypes = {
    label: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
  };
  
  export default FormField;